// src/components/Discussions.js
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../styles/discussion.css";

const Discussions = () => {
  const navigate = useNavigate();
  const { titleSlug } = useParams();
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const backend = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    // Redirect to the login page if the user is not authenticated
    const jwtoken = localStorage.getItem("jwtoken");
    if (jwtoken === null || jwtoken === undefined) {
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchSolutions = async () => {
      try {
        const res = await axios.get(`${backend}/api/solutions/${titleSlug}`);
        setSolutions(res.data);
      } catch (err) {
        setError(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchSolutions();
  }, [titleSlug, backend]);

  const handleVote = async (solutionId, voteType) => {
    try {
      const res = await axios.post(
        `${backend}/api/solutions/vote`,
        { solutionId, voteType },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwtoken")}`,
          },
        }
      );
      // Use the server-returned count so the UI always stays in sync
      setSolutions(
        solutions.map((sol) =>
          sol._id === solutionId ? { ...sol, votes: res.data.votes } : sol
        )
      );
    } catch (err) {
      if (err.response?.status === 401) {
        navigate("/login");
      } else {
        setError(err.response?.data?.message || err.message);
      }
    }
  };

  if (loading) return <>Loading...</>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="discussions-container">
      <h1>Solutions for {titleSlug}</h1>
      <div className="solutions-list">
        {solutions.length === 0 ? (
          <p>No solutions submitted yet. Be the first one!</p>
        ) : (
          solutions.map((solution) => (
            <div
              key={solution._id}
              className="solution-card"
              onClick={() => navigate(`/solution/${solution._id}`)}
            >
              <div className="solution-header">
                <span className="author">{solution.author.Username}</span>
                <span className="votes">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleVote(solution._id, "upvote");
                    }}
                    className="vote-btn"
                  >
                    ↑
                  </button>
                  {solution.votes}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleVote(solution._id, "downvote");
                    }}
                    className="vote-btn"
                  >
                    ↓
                  </button>
                </span>
                <span className="date">
                  {new Date(solution.createdAt).toLocaleDateString()}
                </span>
              </div>
              <pre className="solution-code">
                <code>{solution.code.substring(0, 20)}...</code>
              </pre>
              <div className="solution-footer">
                <span className="language">{solution.language}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Discussions;
